module.exports = __webpack_public_path__ + "img/japan-stomach-cancer-female.5787cc38.png";